import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState, IAddressValidationResponse } from "../";
import { IDonorProfileAddress, IDonorProfileAddressLookupData } from '@nkr/models/index';
import { IDonorProfileAddressPost } from '@nkr/models/donor-profile/donor-address';
import { IPost } from '../authorization';

export interface IDonorProfileDonorAddressResponse {
    data: {
        success: boolean;
        results: IDonorProfileAddress;
    }
}

export interface IDonorProfileDonorAddressLookupDataResponse {
    data: {
        success: boolean;
        results: IDonorProfileAddressLookupData;
    }
}

export interface IDonorProfileDonorAddressPostResponse {
    data: {
        success: boolean;
        results: IDonorProfileAddressPost;
    }
}

export const ActionCreators = {
    getProfileDonorAddress: (donorId: number, centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorProfileDonorAddressResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/donor/${donorId}/address`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    getProfileDonorAddressLookupData: (centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorProfileDonorAddressLookupDataResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/donor/address/lookup-data`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    postProfileDonorAddress: (donorId: number, centerId: number, addressData: IDonorProfileAddressPost) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorProfileDonorAddressPostResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/donor/${donorId}/address`,
            data: addressData
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    validateAddress: (donorId: number, centerId: number, address: string, address2: string, city: string, state: string, postalCode: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IAddressValidationResponse> => {
        let options: IPost = {
            url: `${__API__}/center/${centerId}/donor/${donorId}/validate-address`,
            data: {
                address,
                address2,
                city,
                state,
                postalCode
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    }
}